import { render, staticRenderFns } from "./chemAttachFile.vue?vue&type=template&id=6d81a282"
import script from "./chemAttachFile.vue?vue&type=script&lang=js"
export * from "./chemAttachFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d81a282')) {
      api.createRecord('6d81a282', component.options)
    } else {
      api.reload('6d81a282', component.options)
    }
    module.hot.accept("./chemAttachFile.vue?vue&type=template&id=6d81a282", function () {
      api.rerender('6d81a282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/review/chemAttachFile.vue"
export default component.exports